import { Link } from "react-router-dom";
import styled, { keyframes } from 'styled-components';


const cloudFloat = keyframes`
    0% {
        transform: translateX(540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(-200px);
        opacity: 0;
    }
`;

const cloudFloat2 = keyframes`
    0% {
        transform: translateX(-540px); 
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(540px);
        opacity: 0;
    }
`;

const Cloud = styled.img`
    position: absolute;
    top: 68%;
    width: 100%;
    max-width:60px;
    animation: ${cloudFloat} 30s linear infinite;

    @media (max-width: 520px) {
        max-width:11.5385vw;
    }
`;

const Cloud2 = styled.img`
    position: absolute;
    top: 70%;
    width: 100%;
    max-width:215px;
    animation: ${cloudFloat2} 20s linear infinite;

    @media (max-width: 520px) {
        max-width:41.3462vw;
    }
`;

const Cloud3 = styled.img`
    position: absolute;
    top: 60%;
    width: 100%;
    max-width:115px;
    animation: ${cloudFloat} 30s linear infinite;

    @media (max-width: 520px) {
        max-width:22.1154vw;
    }
`;

const Cloud4 = styled.img`
    position: absolute;
    top: 73%;
    width: 100%;
    max-width:215px;
    animation: ${cloudFloat2} 20s linear infinite;

    @media (max-width: 520px) {
        max-width:41.3462vw;
    }
`;

const Cloud5 = styled.img`
    position: absolute;
    top: 70%;
    width: 100%;
    max-width:60px;
    animation: ${cloudFloat2} 25s linear infinite;

    @media (max-width: 520px) {
        max-width:11.5385vw;
    }
`;


export default function NotFound() {
    return (
        <div className="loadingPage_daetong notfoundPage_daetong">
            <Cloud src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud"/>
            <Cloud2  src={process.env.PUBLIC_URL + '/daetongImg/cloud2.png'} alt="cloud"/>
            <Cloud5 src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud"/>
            <div className="loadingPageDaetong_inner">
                <div className="loadingContent_daetong">
                    <p className="content_scroll top">
                        <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                    </p>
                    <p className="content_scroll bottom">
                        <img src={process.env.PUBLIC_URL + '/daetongImg/content_scroll.png'} alt='' />
                    </p>
                    <div className="loadingBox_daetong">    
                        <h5>404 Error</h5>
                        <p>
                            이 페이지를 표시할 수 없습니다.<br/>
                            나중에 다시 시도하세요.
                        </p>
                        <Link to="/daetong" className="go_home">홈으로 돌아가기</Link>
                    </div>
                </div>

                <div className="mountainPeak_box">
                    <div className="mountainPeak_inner">
                        <Cloud3 src={process.env.PUBLIC_URL + '/daetongImg/cloud.png'} alt="cloud" />
                        <Cloud4 src={process.env.PUBLIC_URL + '/daetongImg/cloud2.png'} alt="cloud" />
                        <img src={process.env.PUBLIC_URL + '/daetongImg/mountain_peak.png'} />
                    </div>
                </div>
            </div>
        </div>
    )
}